module.exports = __webpack_public_path__ + "static/img/7.f6dc015.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/3/eng/7.png
// module id = Ow2j
// module chunks = 0